import { Box, Theme } from "@outschool/backpack";
import { LearnerRoutes } from "@outschool/routes";
import { Loading } from "@outschool/ui-legacy-component-library";
import { Redirect } from "@outschool/ui-utils";
import { useRoutes } from "@patched/hookrouter";
import React from "react";

import { useLearnerClassroomContext } from "../providers/LearnerClassroomProvider";
import { LessonsNavDrawerProvider } from "../providers/LessonsNavDrawerProvider";
import ClassroomHeaderV2 from "../routes/LearnerClassroom/ClassroomHeaderV2";
import {
  classroomRoutes,
  tabValues,
} from "../routes/LearnerClassroom/classroomRoutes";
import { NotFoundPage } from "../routes/NotFoundPage";
import Footer from "./nav/Footer";
import Header from "./nav/Header";

const MAX_WIDTH = 1296;

/** V2 layout: no tabs, full-width content area with header/footer. */
const LearnerClassroomV2Layout = () => {
  const { loading, classroom, sectionUid } = useLearnerClassroomContext();
  const tab = useRoutes(classroomRoutes);

  if (loading) {
    return <Loading />;
  }

  if (!tab || !classroom) {
    return <NotFoundPage />;
  }

  const { value, renderPage } = tab;

  if (value === tabValues.Classroom) {
    return <Redirect to={LearnerRoutes.lessonsPath(sectionUid)} />;
  }

  return (
    <LessonsNavDrawerProvider>
      <Box flex sx={{ flexDirection: "column", minHeight: "100vh" }}>
        <Header
          sx={{
            position: "relative",
            backgroundColor: "white",
            minHeight: 60,
            boxShadow: "0px 2px 5px rgba(23, 25, 28, 0.1)",
          }}
          includeFindClasses={false}
        />
        {/* Mixer: class header bar */}
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 10,
            backgroundColor: "background.paper",
            width: "100%",
            boxShadow:
              "0px 1px 4px rgba(0, 0, 0, 0.04), 0px 1px 8px rgba(0, 0, 0, 0.04)",
          }}
        >
          <Box
            sx={(theme: Theme) => ({
              maxWidth: MAX_WIDTH,
              width: "100%",
              margin: "0 auto",
              [theme.breakpoints.down("md")]: { padding: "1.6rem" },
            })}
          >
            <ClassroomHeaderV2 />
          </Box>
        </Box>
        {/* Content area */}
        <Box
          sx={(theme: Theme) => ({
            maxWidth: MAX_WIDTH,
            width: "100%",
            margin: "0 auto",
            flex: 1,
            [theme.breakpoints.down("md")]: { padding: "1.6rem" },
          })}
        >
          {renderPage()}
        </Box>
        <Footer sx={{ marginTop: "2rem" }} />
      </Box>
    </LessonsNavDrawerProvider>
  );
};

export default LearnerClassroomV2Layout;
